
const navItems = [
  ['services', 'Services'],
  ['stacks', 'Stacks'],
  ['projects', 'Projects'],
  ['resume', 'Resume', { hashRouter: true }],
  ['contact', 'Contact']
].map(navItem => {
  const navItemBuild = ['name', 'title', 'link'].reduce((acc, key, ix) => {
    acc[key] = navItem[ix];
    return acc;
  }, {});

  if (!navItemBuild.link) {
    navItemBuild.link = {
      scroll: true
    };
  }

  return navItemBuild;
});

export default navItems;



// WEBPACK FOOTER //
// ./src/app_data/nav_items.js